<template>
  <el-dialog
    v-if="dialogVisible"
    :title="multiple ? '批量分配' : '分配'"
    :visible.sync="dialogVisible"
    :width="'500px'"
    :close-on-click-modal="false"
    append-to-body
    @close="cancelDialogVisible"
  >
    <div class="dialog-body addmember-body">
      <el-form ref="searchForm" :model="form" :inline="true" :rules="rules">
        <el-form-item v-if="envCrm" label="选择系统版本">
          <el-radio-group v-model="form.versionType">
            <el-radio :label="1">集团CRM</el-radio>
            <el-radio :label="2">渠道CRM</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="form.versionType === 1 || !envCrm"
          label="选择业务员"
          prop="salesmanCode"
          :rules="rules.salesmanCode"
        >
          <el-select
            clearable
            filterable
            v-model="form.salesmanCode"
            value-key="code"
            @change="getSalesmanCode"
          >
            <el-option
              v-for="item in clerkList"
              :label="`${item.userName} - ${item.loginId}`"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
          </el-select>
          <p class="tip" v-if="!buttonVisible">
            该业务员名下客户已满，无法继续分配更多客户！
          </p>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <crm-button
        :buttonType="'plain'"
        :text="'取消'"
        @click="cancelDialogVisible"
      >
      </crm-button>

      <crm-button
        v-if="highSeaAuth.allocationCustomer.toggleStatus && envCrm"
        :disabled="!buttonVisible && form.versionType === 1"
        :loading="allocationLoading"
        :text="'确定'"
        @click="handleDistribute"
      ></crm-button>
      <crm-button
        v-if="highSeaAuth.allocationCustomer.toggleStatus && !envCrm"
        :disabled="!buttonVisible"
        :loading="allocationLoading"
        :text="'确定'"
        @click="handleDistribute"
      ></crm-button>
    </div>
  </el-dialog>
</template>
<script>
import customerApi from '@/services/api/customer';
import customRecycleApi from '@/services/api/customRecycle';
import cookie from 'js-cookie';

import crmButton from '@/components/base/crmButton';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    var validatorName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入角色名称'));
      } else if (value === ' ') {
        callback(new Error('请输入正确的内容'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      dialogVisible: false,
      // 是否是对内系统 env_crm__ true 默认是
      envCrm: null,
      form: {
        ids: [],
        versionType: 1,
        salesmanCode: '',
      },
      clerkList: [],
      buttonVisible: true,
      rules: {
        salesmanCode: [
          { required: true, message: '请选择业务员', trigger: 'change' },
        ],
      },
      allocationLoading: false,
    };
  },
  props: {
    multiple: Boolean || String,
  },
  components: {
    crmButton,
  },
  computed: {
    ...mapGetters({
      customAuth: 'authority/customAuth',
      highSeaAuth: 'authority/auth',
      customerHoldBoolean: 'customer/customerHoldBoolean',
    }),
  },
  async mounted() {
    this.envCrm = cookie.get('_env_crm__') !== 'false';
    await this.getAuthority({ menuUrl: '/cusRecycle' });
    await this.getClerkList();
  },
  methods: {
    ...mapActions({
      getAuthority: 'authority/getAuthority',
      getCustomType: 'common/getCustomType',
      getCustomerHold: 'customer/getCustomerHold',
    }),
    cancelDialogVisible() {
      this.form.salesmanCode = '';
      this.dialogVisible = false;
      this.$emit('close');
    },
    async getSalesmanCode(val) {
      await this.getCustomerHold({
        salesmanCode: val,
      });
      if (this.customerHoldBoolean) {
        this.buttonVisible = true;
      } else {
        this.buttonVisible = false;
      }
    },
    getClerkList() {
      if (this.highSeaAuth.highseaQueryTeamUser.toggleStatus) {
        customRecycleApi
          .queryTeamUser({
            userName:
              this.form.versionType === '1' ? this.form.salesmanCode : '',
            loginId:
              this.form.versionType !== '1' ? this.form.salesmanCode : '',
          })
          .then((res) => {
            this.clerkList = res.data.data;
          });
      }
    },
    handleDistribute() {
      if (!this.highSeaAuth.allocationCustomer.toggleStatus) {
        this.$message({
          message: '暂无权限！',
          type: 'error',
        });
        return;
      }
      this.$refs.searchForm.validate().then((valid) => {
        if (valid) {
          this.allocationLoading = true;
          customRecycleApi
            .allocationCustomer({
              ...this.form,
              versionType: !this.envCrm ? 1 : this.form.versionType,
            })
            .then((res) => {
              // const statusTip = {
              //   0: '全部申请成功!',
              //   1: '部分申请成功!',
              //   2: '分配失败!',
              // };
              this.$message({
                // message: statusTip[res.data.data],
                message: res.data.data,
                // type: res.data.data === 2 ? 'error' : 'success',
              });
              this.cancelDialogVisible();
              this.$emit('success');
            })
            .finally(() => {
              this.allocationLoading = false;
            });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-input-group__prepend {
  width: 150px !important;
}
/deep/ .el-input__inner {
  padding-right: 50px;
}
/deep/ .el-textarea__inner::-webkit-input-placeholder {
  font-size: 12px;
}
/deep/ .el-textarea__inner::-moz-input-placeholder {
  font-size: 12px;
}
/deep/ .el-textarea__inner::-ms-input-placeholder {
  font-size: 12px;
}
/deep/ .el-form-item {
  margin-bottom: 0;
}
/deep/ .el-textarea__inner {
  max-height: 100px;
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  background-color: rgb(67, 96, 255);
  color: #fff;
}
/deep/ .el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  background-color: #4360ff;
}
.tip {
  font-size: 12px;
  color: #f56c6c;
}
</style>
